/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * A link between a toolset and an environment
 */
export type ToolsetEnvironmentLink = {
  /**
   * The ID of the environment
   */
  environmentId: string;
  /**
   * The ID of the toolset environment link
   */
  id: string;
  /**
   * The ID of the toolset
   */
  toolsetId: string;
};

/** @internal */
export const ToolsetEnvironmentLink$inboundSchema: z.ZodMiniType<
  ToolsetEnvironmentLink,
  unknown
> = z.pipe(
  z.object({
    environment_id: z.string(),
    id: z.string(),
    toolset_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "environment_id": "environmentId",
      "toolset_id": "toolsetId",
    });
  }),
);

export function toolsetEnvironmentLinkFromJSON(
  jsonString: string,
): SafeParseResult<ToolsetEnvironmentLink, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ToolsetEnvironmentLink$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ToolsetEnvironmentLink' from JSON`,
  );
}
